/* B3 AIR landing page: bundle picker, sticky bar, gallery and reviews.
   Loaded only by the landing page. Adds to the bag through the theme's own cart drawer (window.B3.add in b3.js). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function nice(t) { t = String(t).toLowerCase(); return t.charAt(0).toUpperCase() + t.slice(1); }

  var buy = document.querySelector('[data-lp-buy]');
  var data = null;
  try { var el = buy && buy.querySelector('[data-lp-json]'); data = el ? JSON.parse(el.textContent) : null; } catch (e) { data = null; }

  /* The announcement bar points at the homepage bundles; on this page, send it to the picker instead. */
  var ann = document.querySelector('.b3-announce a');
  if (ann && buy) ann.setAttribute('href', '#lp-buy');

  function send(items, btn) {
    if (window.B3 && typeof window.B3.add === 'function') return window.B3.add(items, btn);
    if (btn) btn.disabled = true;
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () { window.location.href = root + 'cart'; });
  }

  if (data && data.scents && data.scents.length) {
    var scents = data.scents, byId = {};
    scents.forEach(function (s) { byId[s.id] = s; });
    var picker = buy.querySelector('#lp-picker');
    var statusEl = buy.querySelector('[data-lp-status]');
    var live = buy.querySelector('[data-lp-live]');
    var noteEl = buy.querySelector('[data-lp-note]');
    function say(msg) { if (live) live.textContent = msg; if (noteEl) { noteEl.textContent = msg; noteEl.classList.remove('is-flash'); void noteEl.offsetWidth; noteEl.classList.add('is-flash'); } }
    var n = data.qty, picks = [];

    /* picks holds one variant id per can, oldest first. Starts as the first scents in order (Savage, Greed, Rada). */
    function countOf(id) { var c = 0; picks.forEach(function (p) { if (p === id) c++; }); return c; }
    /* Top up with the scents the customer has least of (in collection order); when shrinking, keep their earliest choices. */
    function fill() {
      while (picks.length < n) {
        var best = scents[0].id, low = Infinity;
        scents.forEach(function (s) { var c = countOf(s.id); if (c < low) { low = c; best = s.id; } });
        picks.push(best);
      }
      if (picks.length > n) picks = picks.slice(0, n);
    }
    fill();
    function totals() {
      var prices = picks.map(function (id) { return byId[id].price; }).sort(function (a, b) { return a - b; });
      var full = prices.reduce(function (a, b) { return a + b; }, 0);
      var free = Math.floor(picks.length / 3), off = 0;
      for (var i = 0; i < free; i++) off += prices[i];
      return { full: full, total: full - off, free: free };
    }
    function summary() {
      var counts = {}, order = [];
      picks.forEach(function (id) { if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
      var parts = order.map(function (id) { return (counts[id] > 1 ? counts[id] + ' × ' : '') + nice(byId[id].title); });
      return parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0];
    }
    function flash(id) {
      var tile = picker && picker.querySelector('[data-lp-tile="' + id + '"]');
      if (!tile) return;
      tile.classList.remove('is-flash'); void tile.offsetWidth; tile.classList.add('is-flash');
      setTimeout(function () { tile.classList.remove('is-flash'); }, 900);
    }

    function update() {
      var t = totals(), left = n - picks.length;
      var more = 'Choose ' + left + ' more scent' + (left > 1 ? 's' : '');
      var label = left > 0 ? more : 'Add to bag &middot; ' + money(t.total) + (t.free ? ' <s>' + money(t.full) + '</s>' : '');
      $$('[data-lp-add]').forEach(function (b) { if (!b.closest('[data-lp-sticky]')) b.innerHTML = label; });
      if (picker) {
        $$('[data-lp-tile]', picker).forEach(function (tile) {
          var c = countOf(+tile.getAttribute('data-lp-tile'));
          tile.classList.toggle('is-on', c > 0);
          tile.querySelector('[data-lp-num]').textContent = c;
          tile.querySelector('[data-lp-dec]').disabled = c === 0;
        });
      }
      if (statusEl) {
        statusEl.textContent = left > 0 ? picks.length + ' of ' + n + ' chosen' : n + ' of ' + n + ' chosen' + (t.free ? ' · ' + t.free + ' free' : '');
        statusEl.classList.toggle('is-done', left === 0);
      }
      var title = $$('[data-lp-sticky-title]')[0];
      var note = $$('[data-lp-sticky-note]')[0];
      if (title) title.innerHTML = left > 0 ? more : n + (n === 1 ? ' can' : ' cans') + ' &middot; ' + money(t.total);
      if (note) note.textContent = left > 0 ? picks.length + ' of ' + n + ' chosen' : (t.free ? t.free + ' free + free UK delivery' : 'Add 2 more cans, get 1 free');
      var stickyBtn = document.querySelector('[data-lp-sticky] [data-lp-add]');
      if (stickyBtn) stickyBtn.textContent = left > 0 ? 'Pick scents' : 'Add to bag';
      var pick = $$('[data-lp-final-pick]')[0];
      if (pick) pick.innerHTML = picks.length ? 'Your bundle: <span>' + esc(summary()) + '</span>' : 'Pick your scents above.';
      $$('[data-lp-tier]', buy).forEach(function (r) { r.closest('.b3-lp-tier').classList.toggle('is-on', r.checked); });
    }

    function add(id) {
      var swapped = null;
      if (picks.length >= n) swapped = picks.shift();
      picks.push(id);
      update(); flash(id);
      var hint = n < 3 ? ', or choose 3 cans below to get 1 free' : n < 6 ? ', or choose 6 cans below to get 2 free' : '';
      say(swapped && swapped !== id
        ? 'Swapped ' + nice(byId[swapped].title) + ' for ' + nice(byId[id].title) + '. Bundle full: tap − to remove one' + hint + '.'
        : nice(byId[id].title) + ' added. ' + (picks.length < n ? 'Choose ' + (n - picks.length) + ' more.' : 'Bundle complete, ready to add to bag.'));
    }
    function remove(id) {
      var i = picks.lastIndexOf(id);
      if (i < 0) return;
      picks.splice(i, 1);
      update();
      say(nice(byId[id].title) + ' removed. Choose ' + (n - picks.length) + ' more.');
    }
    function showPicker() {
      if (!picker) return;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (statusEl) { statusEl.classList.remove('is-flash'); void statusEl.offsetWidth; statusEl.classList.add('is-flash'); }
    }

    $$('[data-lp-tier]', buy).forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        n = +r.value; fill(); update();
      });
    });

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-lp-add]');
      if (addBtn) {
        e.preventDefault();
        if (picks.length < n) { showPicker(); say('Choose ' + (n - picks.length) + ' more scent' + (n - picks.length > 1 ? 's' : '') + ' to complete your bundle.'); return; }
        var counts = {}, order = [];
        picks.forEach(function (id) { if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
        send(order.map(function (id) { return { id: id, quantity: counts[id] }; }), addBtn);
        return;
      }
      var set = e.target.closest('[data-lp-set]');
      if (set && data.set) { e.preventDefault(); send([{ id: data.set.id, quantity: 1 }], set); return; }
      var inc = e.target.closest('[data-lp-inc]');
      if (inc) { e.preventDefault(); var a = +inc.getAttribute('data-lp-inc'); if (byId[a]) add(a); return; }
      var dec = e.target.closest('[data-lp-dec]');
      if (dec) { e.preventDefault(); var d = +dec.getAttribute('data-lp-dec'); if (byId[d]) remove(d); return; }
      var pickBtn = e.target.closest('[data-lp-pick]');
      if (pickBtn) {
        e.preventDefault();
        var id = +pickBtn.getAttribute('data-lp-pick');
        if (!byId[id]) return;
        add(id);
        showPicker();
      }
    });

    update();

    /* Sticky bar: hidden on arrival. It appears only once the visitor has scrolled past the reviews
       (or past the buy box if there is no reviews section), and hides again whenever a page "Add to bag" button is on screen. */
    var sticky = document.querySelector('[data-lp-sticky]');
    var mainCta = buy.querySelector('.b3-lp-cta');
    var finalSec = document.querySelector('[data-lp-final]');
    var finalBtn = finalSec && finalSec.querySelector('[data-lp-add]');
    var gate = document.getElementById('lp-reviews') || buy;
    if (sticky && mainCta) {
      var stickyBtn = sticky.querySelector('button');
      var seen = function (el) { if (!el) return false; var b = el.getBoundingClientRect(); return b.bottom > 0 && b.top < window.innerHeight; };
      var ticking = false;
      var setSticky = function () {
        ticking = false;
        var on = gate.getBoundingClientRect().bottom < 0 && !seen(mainCta) && !seen(finalBtn);
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(setSticky); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      setSticky();
    }
  } else {
    $$('[data-lp-pick]').forEach(function (b) { b.hidden = true; });
  }

  /* Same-day dispatch countdown, in UK time. Working days are Monday to Friday, excluding the dates set in the theme editor. */
  (function () {
    var els = $$('[data-lp-dispatch]');
    if (!els.length || !window.Intl) return;
    var cut = +els[0].getAttribute('data-cutoff') || 13;
    var hol = (els[0].getAttribute('data-holidays') || '').split(/[\s,]+/).filter(Boolean);
    var label = cut === 12 ? '12pm' : cut > 12 ? (cut - 12) + 'pm' : cut + 'am';
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var fmt;
    try { fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); } catch (e) { return; }
    function uk() {
      var o = {}; fmt.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour, min: +o.minute };
    }
    function key(dt) { return dt.getUTCFullYear() + '-' + ('0' + (dt.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + dt.getUTCDate()).slice(-2); }
    function working(dt) { var w = dt.getUTCDay(); return w > 0 && w < 6 && hol.indexOf(key(dt)) < 0; }
    function render() {
      var t = uk(), today = new Date(Date.UTC(t.y, t.m - 1, t.d)), html;
      var left = cut * 60 - (t.h * 60 + t.min);
      if (working(today) && left > 0) {
        var hh = Math.floor(left / 60), mm = left % 60;
        html = 'Order within <b>' + (hh ? hh + 'h ' : '') + mm + 'm</b> for <b>same-day dispatch</b>';
      } else {
        var next = new Date(today.getTime()), i = 0;
        do { next = new Date(next.getTime() + 864e5); i++; } while (!working(next) && i < 14);
        var when = i === 1 ? 'tomorrow' : days[next.getUTCDay()];
        html = 'Order by ' + label + ' ' + when + ' for <b>same-day dispatch</b>';
      }
      els.forEach(function (el) { var s = el.querySelector('[data-lp-dispatch-text]'); if (s) s.innerHTML = html; });
    }
    render();
    setInterval(render, 30000);
  })();

  /* Gallery */
  $$('[data-lp-gallery]').forEach(function (g) {
    var track = g.querySelector('.b3-lp-gallery__track');
    var dots = $$('.b3-lp-gallery__dots span', g);
    var thumbs = $$('.b3-lp-gallery__thumbs button', g);
    if (!track) return;
    function set(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(i === j)); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); set(i); });
    });
    var tm;
    track.addEventListener('scroll', function () {
      clearTimeout(tm);
      tm = setTimeout(function () { set(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
  });

  /* Reviews carousel */
  $$('[data-lp-reviews]').forEach(function (r) {
    var tr = r.querySelector('[data-lp-track]');
    var prev = r.querySelector('[data-lp-prev]');
    var next = r.querySelector('[data-lp-next]');
    if (!tr || !prev || !next) return;
    var cards = $$('.b3-lp-review', tr);
    var dotsWrap = r.querySelector('[data-lp-dots]');
    if (dotsWrap) dotsWrap.innerHTML = cards.map(function () { return '<span></span>'; }).join('');
    var dots = dotsWrap ? $$('span', dotsWrap) : [];
    function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 12 : tr.clientWidth; }
    function state() {
      prev.disabled = tr.scrollLeft < 4;
      next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
      var i = next.disabled ? cards.length - 1 : Math.round(tr.scrollLeft / step());
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    prev.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    var tm;
    tr.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(state, 80); }, { passive: true });
    window.addEventListener('resize', state);
    state();
  });
})();